import { IState } from '../../store';
import { getNewbuildingsListQueryStringUrl } from '../../utils/formatters';

export const selectNewbuildingFromDeveloperUrl = (state: IState): string => {
  const queryString = state.offerData.company?.stats?.newbuildingCount.qs;

  return queryString ? getNewbuildingsListQueryStringUrl(queryString) : '';
};
